<template>
  <router-view />
</template>

<style lang="scss">
@import 'assets/bootstrap/scss/bootstrap';
@import "assets/scss/all.scss";
</style>
